import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import axios from "axios";
import { toast } from "react-toastify";
import Switch from "react-switch";

import DefaultButton from "../../Common/DefaultButton";
import GlobalContext from "../../../Hooks/globalContext";
import { HOST, NUMBER_REGEX } from "../../../Utils/constants";
import useState from "../../../Hooks/useState";
import Input from "../../Common/Input";
import useInput from "../../../Hooks/useInput";
import Loader from "../../Common/Loader";

const Top = styled.div`
  padding: 10px;
  height: calc(100% - 60px);
  width: 100%;
  overflow: auto;
`;

const Bottom = styled.div`
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px;
`;

const BottomItem = styled.div``;

const InnerBox = styled.div`
  :first-child {
    margin-bottom: 25px;
  }
`;

const InnerTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
`;

const InnerContent = styled.div`
  padding: 10px;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 700px;
`;

const InputWrapper = styled.div`
  max-width: 320px;
  width: 100%;
`;

const Page = ({ adminPage, focus }) => {
  const { httpHeader, modal, language, web3 } = useContext(GlobalContext);
  const myConfig = useState(null);
  const adminInput = useInput({ defaultValue: "", maxLength: 43 });
  const dayInput = useInput({ defaultValue: "", maxLength: 6, regex: NUMBER_REGEX });
  const perInput = useInput({ defaultValue: "", maxLength: 6, regex: NUMBER_REGEX });
  const minInput = useInput({ defaultValue: "", maxLength: 6, regex: NUMBER_REGEX });
  const checked = useState(null);

  const getConfig = async () => {
    const requestBody = { type: "read" };
    const { data } = await axios.post(`${HOST}/admin/config`, requestBody, httpHeader());
    checked.setState(data.staking_available === 1);
    dayInput.setValue(data.staking_day);
    perInput.setValue(data.staking_per);
    minInput.setValue(data.staking_min);
    adminInput.setValue(data.admin_wallet);

    myConfig.setState(data);
  };

  const updateOnClick = async () => {
    const requestBody = {
      type: "update",
      day: dayInput.value,
      per: perInput.value,
      min: minInput.value,
      admin: adminInput.value,
      status: checked.state,
    };

    if (!web3.utils.isAddress(adminInput.value)) {
      return modal.setState("올바른 지갑주소가 아닙니다.");
    }

    if (isNaN(Number(adminInput.value)) || isNaN(Number(dayInput.value)) || isNaN(Number(perInput.value)) || isNaN(Number(minInput.value))) {
      return modal.setState("입력값을 확인해주세요.");
    }

    const { data } = await axios.post(`${HOST}/admin/config`, requestBody, httpHeader());

    if (data) {
      modal.setState("변경사항이 적용되었습니다.");
      getConfig();
    }
  };

  const switchOnChange = async () => {
    const requestBody = {
      type: "toggle",
      status: checked.state,
      id: myConfig.state.id,
    };
    const { data } = await axios.post(`${HOST}/admin/config`, requestBody, httpHeader());

    if (data === true) {
      modal.setState(checked.state ? "모든 유저의 스테이킹을 차단합니다." : "모든 유저의 스테이킹을 허용합니다.", {
        toastId: "switch",
        autoClose: 2000,
      });
      checked.setState(!checked.state);
    }
  };

  const preload = () => {
    getConfig();
  };

  useEffect(preload, []);
  return myConfig.state ? (
    <>
      <Top>
        <InnerBox>
          <InnerTitle>{"설정 변경"}</InnerTitle>
          <InnerContent>
            <div>{"관리자 지갑"}</div>
            <InputWrapper>
              <Input style={{ backgroundColor: "white", color: "black" }} {...adminInput} placeholder={"admin wallet"} />
            </InputWrapper>  </InnerContent>
          <InnerContent>
            <div>{"스테이킹 가능 상태 조정"}</div>
            <div>{checked.state !== null && <Switch onChange={switchOnChange} checked={checked.state} />}</div>
          </InnerContent>
          <InnerContent>
            <div>{"스테이킹 일(Day)"}</div>
            <InputWrapper>
              <Input style={{ backgroundColor: "white", color: "black" }} {...dayInput} placeholder={"day"} />
            </InputWrapper>
          </InnerContent>
          <InnerContent>
            <div>{"스테이킹 보상 지급 비율(%)"}</div>
            <InputWrapper>
              <Input
                style={{ backgroundColor: "white", color: "black" }}
                {...perInput}
                placeholder={"변경할 관리자 지갑 주소"}
              />
            </InputWrapper>
          </InnerContent>
          <InnerContent>
            <div>{"최소 스테이킹 수량"}</div>
            <InputWrapper>
              <Input
                style={{ backgroundColor: "white", color: "black" }}
                {...minInput}
                placeholder={"이더 전송 수수료"}
              />
            </InputWrapper>
          </InnerContent>
        </InnerBox>
      </Top>
      <Bottom>
        <BottomItem></BottomItem>
        <BottomItem></BottomItem>
        <BottomItem>
          <DefaultButton style={{ padding: "10px 15px" }} text={"변경"} onClick={updateOnClick} />
        </BottomItem>
      </Bottom>
    </>
  ) : (
      <Loader />
    );
};

export default Page;
